import React from "react";
import { Accordion, Box, Grid, Stack, Text, Textarea } from "@mantine/core";
import { useServicePlanStyles } from "../style";
import ServicePlanAccordion from "../ServicePlanAccordion";
import { IconChevronDown } from "@tabler/icons-react";
// import ServicePlanAccordion from '../ServicePlanAccordion';
// import { useServicePlanStyles } from '../ServicePlanStyles';

export const nutritionItems = [
  {
    name: "Appetite",

    subItems: [{ name: "Excellent" }, { name: "Good" }, { name: "Poor" }],
  },
  {
    name: "Texture",

    subItems: [{ name: "Regular" }, { name: "Mech Soft" }, { name: "Puree" }],
  },
  {
    name: "Liquids",

    subItems: [
      { name: "Regular" },
      { name: "Nectar Thick" },
      { name: "Honey Thick" },
    ],
  },
];

export const mealLocationItems = [
  {
    name: "Eats Meals at Table",
  },
  {
    name: "Eats in Bed",
  },
  {
    name: "Special Aids",
  },
];

export const feedingAssistanceItems = [
  {
    name: "Partial Assistance",
  },
  {
    name: "Full Assistance",
  },
  {
    name: "Cueing and Supervision",
  },
  {
    name: "Cut up meat and vegetables",
  },
  {
    name: "Encourage Meals and Snacks",
  },
];

export const hydrationItems = [
  {
    name: "Encourage Sufficient Fluids",
  },
  {
    name: "Flush G-tube with",
    subItems: [{ name: "Before" }, { name: "After" }],
  },
  {
    name: "Fluids Restrictions",
  },
];

export const assistiveDevicesItems = [
  {
    name: "Walker",
  },
  {
    name: "Wheelchair",
  },
  {
    name: "Hoyer Lift",
  },
  {
    name: "Independent",
  },
  {
    name: "Bedside Commode",
  },
  {
    name: "Shower Chair",
  },
  {
    name: "Cane",
  },
];

export const visionItems = [
  {
    name: "Unimpaired",
  },
  {
    name: "Reading Glasses",
  },
  {
    name: "RX Glasses",
  },
  {
    name: "Blind",
  },
  {
    name: "Right",
  },
  {
    name: "Left",
  },
];

export const speechItems = [
  {
    name: "Clear",
  },
  {
    name: "Slurred/garbled",
  },
  {
    name: "Word Salad",
  },
  {
    name: "Aphasia",
  },
  {
    name: "Nonsensical at times",
  },
];

export const hearingItems = [
  {
    name: "Unimpaired",
  },
  {
    name: "Impaired",
  },
  {
    name: "Right",
  },
  {
    name: "Left",
  },
  {
    name: "Hearing Aids",
  },
];

// TOILETING
export const toileting = [
  {
    name: "Independent",

    subItems: [{ name: "Reminder - Q2H" }],
  },
  {
    name: "Dependent",

    subItems: [{ name: "1-2 CG" }],
  },
  {
    name: "Continent",

    subItems: [{ name: "Bladder" }, { name: "Bowel" }],
  },
  {
    name: "Incontinent",

    subItems: [
      { name: "Bladder" },
      { name: "Bowel" },
      { name: "Mixed Incontinence" },
    ],
  },
  {
    name: "Accidents",

    subItems: [
      { name: "Bladder" },
      { name: "Bowel" },
      { name: "Night Incontinence" },
    ],
  },
  {
    name: "Foley Cather",

    subItems: [{ name: "Change" }, { name: "Empty PRN" }],
  },
  {
    name: "Colostomy",

    subItems: [{ name: "Change" }, { name: "Empty PRN" }],
  },
];

export const brushingTeeth = [
  {
    name: "Independent with Setup",

    subItems: [{ name: "Daily" }, { name: "PRN" }, { name: "Reminder" }],
  },
  {
    name: "Dependent",

    subItems: [{ name: "Daily" }, { name: "PRN" }, { name: "Picking Out" }],
  },
  {
    name: "Dentures",

    subItems: [{ name: "Full" }, { name: "Upper" }, { name: "Lower" }],
  },
  { name: "Brush and soak dentures overnight" },
  { name: "Resident does not remove dentures" },
  { name: "No teeth swab gums" },
];

// BED CHECK
export const bedCheck = [
  {
    name: "Make Bed",

    subItems: [{ name: "Independent" }, { name: "Dependent" }],
  },
  {
    name: "Change Linen 1/Week (PRN)",

    subItems: [{ name: "Independent" }, { name: "Dependent" }],
  },
  {
    name: "Diabetic Check",

    subItems: [
      { name: "Bruises/Cuts, Color, Temperature of feet" },
      { name: "Toe Nails/Finger Nails" },
      { name: "Podiatrist for a fee" },
      { name: "Bed Positioning" },
      { name: "Call Light Access Check" },
      { name: "Room Safety Tidy" },
      { name: "Night Check or Bed Check" },
    ],
  },
];

// SKIN CARE
export const skinCare = [
  { name: "PRN Lotion" },
  { name: "Monitor Skin Integrity" },
  { name: "Monitor Boney Areas" },
  { name: "Apply cream/ointment as Prescribed" },
  { name: "Maintain good nutrition and fluid intake" },
  {
    name: "Perineal care as needed with every brief change",
  },
  { name: "Pressure relieving device PRN" },
  { name: "Float Heals PRN" },
];

// NUTRITION AND HYDRATION
export const nutritionAndHydration = [
  { name: "Breakfast Assistance" },
  { name: "Lunch Assistance" },
  { name: "Dinner Assistance" },
  { name: "Snack Assistance" },
  { name: "Water or Hydration Support" },
  { name: "Feeding Assistance" },
  { name: "Meal Setup" },
  { name: "Cueing to Eat" },
  { name: "Monitor Intake" },
];

// UNDERGARMENTS
export const undergarments = [
  { name: "Underwear", hasTextInput: true },
  {
    name: "Independent",

    subItems: [{ name: "Pull-ups" }, { name: "Tape Briefs" }, { name: "Pad" }],
  },
  {
    name: "Dependent",

    subItems: [{ name: "Pull-ups" }, { name: "Tape Briefs" }, { name: "Pad" }],
  },
  { name: "Change Brief - Q2-3 Hrs" },
  { name: "Change Brief PRN" },
];

// DRESSING
export const dressing = [
  {
    name: "Independent",

    subItems: [
      { name: "Clothing" },
      { name: "Socks/Shoes" },
      { name: "Picking Out" },
    ],
  },
  {
    name: "Partial Assistance",

    subItems: [
      { name: "Clothing" },
      { name: "Socks/Shoes" },
      { name: "Picking Out" },
    ],
  },
  {
    name: "Full Assistance",

    subItems: [
      { name: "Clothing" },
      { name: "Socks/Shoes" },
      { name: "Picking Out" },
    ],
  },
];

// GROOMING
export const grooming = [
  {
    name: "Independent",

    subItems: [{ name: "Comb hair" }, { name: "Daily" }, { name: "Reminder" }],
  },
  {
    name: "Dependent",

    subItems: [{ name: "Comb hair" }, { name: "Daily" }],
  },
  { name: "Manicure/Pedicure" },
];

// SHOWER
export const shower = [
  { name: "How many showers weekly?", hasTextInput: true },
  { name: "Shampoo/conditioner" },
  { name: "Body Wash" },
  { name: "Partial Bath PRN" },
  { name: "Full Bed Bath" },
  { name: "Shave PRN" },
];

// OTHER
export const other = [
  { name: "Snack and Water Rounds" },
  { name: "Family Communication Support" },
  { name: "Mood Observation" },
];

const AssessmentStep = ({ data, onChange, view, errors }) => {
  const { classes } = useServicePlanStyles();

  const handleAccordionChange = (section, items) => {
    onChange({
      ...data,
      [section]: items,
    });
  };

  return (
    <Box className={classes.formSection}>
      <Accordion
        className={classes.accordionStyle}
        chevron={<IconChevronDown />}
        chevronPosition="right"
        chevronSize={20}
        variant="separated"
        multiple
        defaultValue={["physicalAssessmentData", "occupationalAssessmentData"]}
      >
        <Accordion.Item
          key="physicalAssessmentData"
          value="physicalAssessmentData"
        >
          <Accordion.Control>Physical Assessment</Accordion.Control>
          <Accordion.Panel>
            <Grid>
              <Grid.Col span={12} sm={6} md={3} lg={3}>
                <ServicePlanAccordion
                  title="Nutrition"
                  items={nutritionItems}
                  selectedItems={data?.nutrition || []}
                  onChange={(items) =>
                    handleAccordionChange("nutrition", items)
                  }
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={12} sm={6} md={3} lg={3}>
                <ServicePlanAccordion
                  title="Meals Location"
                  items={mealLocationItems}
                  selectedItems={data.mealsLocation || []}
                  onChange={(items) =>
                    handleAccordionChange("mealsLocation", items)
                  }
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={12} sm={6} md={3} lg={3}>
                <ServicePlanAccordion
                  title="Feeding Assistance"
                  items={feedingAssistanceItems}
                  selectedItems={data.feedingAssistance || []}
                  onChange={(items) =>
                    handleAccordionChange("feedingAssistance", items)
                  }
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={12} sm={6} md={3} lg={3}>
                <ServicePlanAccordion
                  title="Hydration"
                  items={hydrationItems}
                  selectedItems={data.hydration || []}
                  onChange={(items) =>
                    handleAccordionChange("hydration", items)
                  }
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={12} sm={6} md={3} lg={3}>
                <ServicePlanAccordion
                  title="Assistive Devices"
                  items={assistiveDevicesItems}
                  selectedItems={data.assistiveDevices || []}
                  onChange={(items) =>
                    handleAccordionChange("assistiveDevices", items)
                  }
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={12} sm={6} md={3} lg={3}>
                <ServicePlanAccordion
                  title="Vision"
                  items={visionItems}
                  selectedItems={data.vision || []}
                  onChange={(items) => handleAccordionChange("vision", items)}
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={12} sm={6} md={3} lg={3}>
                <ServicePlanAccordion
                  title="Speech"
                  items={speechItems}
                  selectedItems={data.speech || []}
                  onChange={(items) => handleAccordionChange("speech", items)}
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={12} sm={6} md={3} lg={3}>
                <ServicePlanAccordion
                  title="Hearing"
                  items={hearingItems}
                  selectedItems={data.hearing || []}
                  onChange={(items) => handleAccordionChange("hearing", items)}
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={12} sm={6} md={3} lg={3}>
                <ServicePlanAccordion
                  title="Toileting"
                  items={toileting}
                  selectedItems={data.toileting || []}
                  onChange={(items) =>
                    handleAccordionChange("toileting", items)
                  }
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={12}>
                <Textarea
                  label="Notes"
                  placeholder="Add notes here"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.physicalAssessmentNotes}
                  onChange={(e) =>
                    handleAccordionChange(
                      "physicalAssessmentNotes",
                      e.target.value,
                    )
                  }
                />
              </Grid.Col>
            </Grid>
          </Accordion.Panel>
        </Accordion.Item>

        <Accordion.Item
          key="occupationalAssessmentData"
          value="occupationalAssessmentData"
        >
          <Accordion.Control>Occupational Assessment</Accordion.Control>
          <Accordion.Panel>
            <Grid>
              <Grid.Col span={12} sm={6} md={3} lg={3}>
                <ServicePlanAccordion
                  title="Brushing Teeth"
                  items={brushingTeeth}
                  selectedItems={data?.brushingTeeth || []}
                  onChange={(items) =>
                    handleAccordionChange("brushingTeeth", items)
                  }
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={12} sm={6} md={3} lg={3}>
                <ServicePlanAccordion
                  title="Bed Check"
                  items={bedCheck}
                  selectedItems={data?.bedCheck || []}
                  onChange={(items) => handleAccordionChange("bedCheck", items)}
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={12} sm={6} md={3} lg={3}>
                <ServicePlanAccordion
                  title="Skin Care"
                  items={skinCare}
                  selectedItems={data?.skinCare || []}
                  onChange={(items) => handleAccordionChange("skinCare", items)}
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={12} sm={6} md={3} lg={3}>
                <ServicePlanAccordion
                  title="Nutrition and Hydration"
                  items={nutritionAndHydration}
                  selectedItems={data?.nutritionAndHydration || []}
                  onChange={(items) =>
                    handleAccordionChange("nutritionAndHydration", items)
                  }
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={12} sm={6} md={3} lg={3}>
                <ServicePlanAccordion
                  title="Undergarments"
                  items={undergarments}
                  selectedItems={data?.undergarments || []}
                  onChange={(items) =>
                    handleAccordionChange("undergarments", items)
                  }
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={12} sm={6} md={3} lg={3}>
                <ServicePlanAccordion
                  title="Dressing"
                  items={dressing}
                  selectedItems={data?.dressing || []}
                  onChange={(items) => handleAccordionChange("dressing", items)}
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={12} sm={6} md={3} lg={3}>
                <ServicePlanAccordion
                  title="Grooming"
                  items={grooming}
                  selectedItems={data?.grooming || []}
                  onChange={(items) => handleAccordionChange("grooming", items)}
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={12} sm={6} md={3} lg={3}>
                <ServicePlanAccordion
                  title="Shower"
                  items={shower}
                  selectedItems={data?.shower || []}
                  onChange={(items) => handleAccordionChange("shower", items)}
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={12} sm={6} md={3} lg={3}>
                <ServicePlanAccordion
                  title="Other"
                  items={other}
                  selectedItems={data?.other || []}
                  onChange={(items) => handleAccordionChange("other", items)}
                  view={view}
                />
              </Grid.Col>
              <Grid.Col span={12}>
                <Textarea
                  label="Notes"
                  placeholder="Add notes here"
                  className={classes.inputStyle}
                  disabled={view}
                  value={data.occupationalAssessmentNotes}
                  onChange={(e) =>
                    handleAccordionChange(
                      "occupationalAssessmentNotes",
                      e.target.value,
                    )
                  }
                />
              </Grid.Col>
            </Grid>
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </Box>
  );
};

export default AssessmentStep;
